import { Box, Button, CircularProgress } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";
import { colorClassNameMap, stringClassNameMap } from "utils/disagreementsUtils";

const buttons = ["PASS", "FAIL", "UNSURE"];

export interface ButtonItemProps {
  className: string;
  disabled: boolean;
  onSubmit: (className: string) => void;
  currentClassNameAnswer?: string;
}

export function ButtonItem(props: ButtonItemProps) {
  const { className, disabled, onSubmit, currentClassNameAnswer } = props;

  return (
    <Button
      onClick={() => onSubmit(stringClassNameMap[className])}
      disabled={disabled}
      className={`w-auto flex shadow-md text-black pointer-events-auto ${
        disabled ? "cursor-not-allowed bg-gray-300" : "bg-[#E5E9ED]"
      }`}
    >
      <Typography noWrap className="flex gap-1">
        {className === currentClassNameAnswer ? "Retain" : "Change answer to"}
        <Typography textTransform="uppercase" fontWeight="bold" color={colorClassNameMap[className]}>
          {stringClassNameMap[className]}
        </Typography>
        {className === currentClassNameAnswer && "as answer"}
      </Typography>
    </Button>
  );
}

export interface DisagreementsButtonsProps {
  showOptionsButtons: boolean;
  onSubmit: (label: string) => void;
  loading: boolean;
  isClosed: boolean;
  currentClassNameAnswer: string;
}

export function DisagreementsButtons(props: DisagreementsButtonsProps) {
  const { showOptionsButtons, onSubmit, loading, isClosed, currentClassNameAnswer } = props;

  if (loading) {
    return (
      <Box className="flex justify-center items-center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className="flex h-[50px] items-center justify-center gap-2 flex-wrap">
      {showOptionsButtons ? (
        buttons.map((item) => (
          <ButtonItem
            key={item}
            className={item}
            currentClassNameAnswer={currentClassNameAnswer}
            onSubmit={onSubmit}
            disabled={isClosed}
          />
        ))
      ) : (
        <Box className="flex flex-col justify-center items-center gap-2 pointer-events-auto">
          <ButtonItem className="UNSURE" onSubmit={onSubmit} disabled={false} />
        </Box>
      )}
    </Box>
  );
}
